import { AuctionNews } from '@/redux/api/auctionNews';
import { TypedActionWithPayload } from '@/types/redux';

export const LOAD_AUCTION_NEWS_FAIL = 'la/domain/items/LOAD_AUCTION_NEWS_FAIL';
export type LOAD_AUCTION_NEWS_FAIL_ACTION = TypedActionWithPayload<
    typeof LOAD_AUCTION_NEWS_FAIL,
    string,
    {
        search: any;
    }
>;

export const LOAD_AUCTION_NEWS_SUCCESS = 'la/domain/items/LOAD_AUCTION_NEWS_SUCCESS';
export type LOAD_AUCTION_NEWS_SUCCESS_ACTION = TypedActionWithPayload<typeof LOAD_AUCTION_NEWS_SUCCESS, AuctionNews[]>;
